import { Button, Dialog } from '@dittolive/anvil'
import React from 'react'

import { MongoConnectorFeatureFlags } from '../../../types/mongoConnector'
import CollectionForm from './CollectionForm'
import { MongoCollectionFormValue } from './validation'

type Props = {
  /** Whether the modal is open */
  isOpen: boolean
  /** Index of the collection being edited (null for new) */
  index: number | null
  /** Existing collection data when editing */
  editingCollection?: MongoCollectionFormValue | null
  /** Callback when form is submitted successfully */
  onSave: (value: MongoCollectionFormValue) => void
  /** Callback when modal is closed (cancel or after save) */
  onClose: () => void
  /** Feature flags that affect form behavior */
  featureFlags?: MongoConnectorFeatureFlags
}

const FORM_ID = 'addOrUpdateCollectionSubForm'

/**
 * Modal wrapper for CollectionForm.
 * Use this in frontend for the modal experience.
 * For self-managed (no modal), use CollectionForm directly.
 */
export default function AddOrEditCollectionModal({
  isOpen,
  index,
  editingCollection,
  onSave,
  onClose,
  featureFlags,
}: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <Dialog.Content size="lg" data-testid="addOrEditCollectionModal">
        <Dialog.Header>
          <Dialog.Title>
            {editingCollection ? 'Edit' : 'Add'} collection to sync
          </Dialog.Title>
          <Dialog.Description>
            Configure a collection and ID fields to sync with Ditto.
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Body>
          <CollectionForm
            index={index}
            editingCollection={editingCollection}
            onSave={onSave}
            onCancel={onClose}
            featureFlags={featureFlags}
            formId={FORM_ID}
            isActive={isOpen}
          />
        </Dialog.Body>

        <Dialog.Footer>
          <Button size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            form={FORM_ID}
            data-testid="submitButton"
          >
            {editingCollection ? 'Save' : 'Add'} collection
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
